import React, { Component } from "react";
import styled from "styled-components";
import { Redirect } from 'react-router-dom';

// Utils //
import history from "utils/history";

// HOC //
import withChat from "hoc/withChat";

// Components //
import View from 'components/View';
import Text from "components/Text";
import List from 'components/List';
import StepHeader from 'components/StepHeader';

const Root = styled(View)``;

const Header = styled(StepHeader)`
  margin-bottom: 40px;
`;

const TextWrapper = styled(View)`
  & > * + * {
    margin-top: 24px;
  }
`;

class Step7 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasRan: false,
      modalIsOpen: false,
      value: `channel.on("message.new", event => {
  openModal(event);
});
await channel.sendMessage({
  text: "What is the medieval equivalent of tabs vs spaces?",
});`
    };
  }

  run = async () => {
    const { channel, match, setLoading, setError } = this.props; // eslint-disable-line no-unused-vars
    const { value } = this.state;

    try {
      await setLoading(true);
      await eval(`(async () => {${value}})();`); // eslint-disable-line no-eval
      await setLoading(false);

      this.setState({ hasRan: true });
    } catch (err) {
      await setLoading(false);
      setError(err.message);
    }
  };

  openModal = event => {
    this.setState({ event: event.detail });
  };

  handleCodeChange = value => {
    this.setState({
      value
    });
  };

  handlePrevClick = () => history.push(`/step-5`);

  handleNextClick =  () => history.push(`/step-7`);

  render() {
    const {client, channel} = this.props;
    if (!client || !channel) {
      return <Redirect to="/step-1" />
    }

    return (
      <Root>
        <Header
          step={7}
          title="Finished"
        >
          <Text size={18}>
            In 7 simple steps you’ve learned the basics of adding chat to your app. If you have any questions feel free to contact us, we’re happy to help.
          </Text>
        </Header>
        <TextWrapper>
          <Text>
            The <a target="_parent" href="https://getstream.io/chat/docs">documentation</a> covers more advanced concepts such as:
          </Text>
          <List
            items={[
              "Slash Commands like /giphy",
              "Message Attachments",
              "Webhooks",
              "Message Search",
              "AI Powered Moderation",
              "User Presence",
              "Invite to Chat"
            ]}
          />
          <Text>
            If you haven’t tried the <a target="_blank" rel="noopener noreferrer" href="https://getstream.io/chat/react-chat/tutorial/">React components</a> yet, you should have a look at the Chat <a target="_parent" href="https://getstream.io/chat/react-chat/tutorial/">React Component tutorial.</a>
          </Text>
          <Text>
            <a target="_parent" href="https://getstream.io/accounts/chat-signup/">Create an account</a> with Stream to start a trial or get in touch with our team to discuss your use case.
          </Text>
        </TextWrapper>
      </Root>
    );
  }
}
export default withChat(Step7);
